/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cups (250 ml)`)
};

const es_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vasos (250 ml)`)
};

const de_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tassen (250 ml)`)
};

const nl_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glazen (250 ml)`)
};

const fr_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verres (250 ml)`)
};

const it_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bicchieri (250 ml)`)
};

const pt_br2_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copos (250 ml)`)
};

const pt_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chávenas (250 ml)`)
};

const ja_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カップ数 (250ml)`)
};

const zh_water_cups = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`杯数（250 毫升/杯）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_cups = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_cups(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_cups", locale)
	if (locale === "en") return en_water_cups(inputs)
	if (locale === "es") return es_water_cups(inputs)
	if (locale === "de") return de_water_cups(inputs)
	if (locale === "nl") return nl_water_cups(inputs)
	if (locale === "fr") return fr_water_cups(inputs)
	if (locale === "it") return it_water_cups(inputs)
	if (locale === "pt-BR") return pt_br2_water_cups(inputs)
	if (locale === "pt") return pt_water_cups(inputs)
	if (locale === "ja") return ja_water_cups(inputs)
	return zh_water_cups(inputs)
};